import { ExtendedRoles } from 'src/features/workspace/WorkspaceShareMemberRoleSelectProps';
import {
  type Table,
  TableColumnType,
  type TableRow,
} from 'src/generated/graphql';

type Props = {
  table: Table;
  row: TableRow;
  userId: string;
  roles: Record<ExtendedRoles, boolean>;
};

export const useBoardRoleCanView = ({
  table,
  row,
  userId,
  roles,
}: Props): boolean => {
  if (!row) return false;

  if (
    roles[ExtendedRoles.ADMIN] ||
    roles[ExtendedRoles.EDIT_ALL] ||
    roles[ExtendedRoles.VIEW_ALL]
  )
    return true;

  const userColumns = table?.columns?.reduce((acc, curr) => {
    if (curr.type === TableColumnType.Users && curr.field !== 'owner') {
      acc.push(curr._id);
    }
    return acc;
  }, [] as string[]);

  const colValues = row.columns.filter((c) => userColumns.includes(c.columnId));
  if (roles[ExtendedRoles.VIEW_OWN] || roles[ExtendedRoles.EDIT_OWN]) {
    const assignedToMe = colValues.some((c) => c.value.includes(userId));
    const canView = row.owner?._id === userId || assignedToMe;
    if (canView) return true;
  }

  if (
    roles[ExtendedRoles.VIEW_UNASSIGNED] ||
    roles[ExtendedRoles.EDIT_UNASSIGNED]
  ) {
    return colValues.every((c) => !c.value?.length);
  }

  return false;
};
